import { useLocation } from "react-router"

import { cn } from "@/lib/utils"
import { BranchSelector } from "./BranchSelector"
import { DesktopNavigation } from "./DesktopNavigation"
import { HeaderLogo } from "./HeaderLogo"
import { useHeaderScrollState } from "./useHeaderScrollState"

export const Header = () => {
    const { pathname } = useLocation()
    const isScrolled = useHeaderScrollState()
    const usesTransparentTop = pathname === "/" || pathname.startsWith("/thu-vien-anh")
    const isTransparentTop = usesTransparentTop && !isScrolled
    const usesLightForeground = isTransparentTop
    const appearance = isScrolled
        ? "scrolled"
        : isTransparentTop
            ? "home-top"
            : "child-top"

    return (
        <header
            data-appearance={appearance}
            className={cn(
                "fixed inset-x-0 top-0 z-50 h-16 border-b transition-[background-color,border-color,box-shadow,color] duration-300 lg:h-[72px]",
                isScrolled
                    ? "border-[#ded3c6] bg-[#fffdf9] text-[#4a4036] shadow-[0_8px_24px_rgba(67,52,39,0.10)]"
                    : isTransparentTop
                        ? "border-white/20 bg-transparent text-white"
                        : "border-transparent bg-transparent text-[#4a4036]",
            )}
        >
            <div className="mx-auto flex h-full max-w-[1440px] items-center justify-between gap-3 px-4 sm:px-6 lg:gap-2 lg:px-8 xl:gap-5">
                <HeaderLogo />
                <DesktopNavigation lightForeground={usesLightForeground} />
                <BranchSelector lightForeground={usesLightForeground} />
            </div>
        </header>
    )
}
